export default class Deposit {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {number}
   */
  transactionId;

  /**
   * @type {string}
   */
  checkNumber;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.transactionId != null) {
        this.transactionId = opts.transactionId;
      }
      if (opts.checkNumber != null) {
        this.checkNumber = opts.checkNumber;
      }
    }
  }
}
